module.exports = __webpack_public_path__ + "static/img/3872_phase_function_Paper_PointsHejduk_Prediction.fe29fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3872_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VYdT
// module chunks = 0